export function assertIsArray(data, message) {
    if (Object.prototype.toString.call(data) !== '[object Array]') {
        throw new Error(message);
    }
}
export function getValues(data) {
    return Object.keys(data).map(function (key) { return data[key]; });
}
export function getKeys(data) {
    return Object.keys(data);
}
export function getEntries(data) {
    return Object.keys(data).map(function (key) { return [key, data[key]]; });
}
export function normalizeFileName(fileName, extension) {
    var suffix = '.' + extension;
    var extensionPattern = new RegExp("(\\" + extension + ")?$");
    return fileName.replace(/\s+/, '_').replace(extensionPattern, suffix);
}
